<template>
  <el-card>
    <el-tabs type="border-card" @tab-click="TabClick">
      <EASSendDataManage> </EASSendDataManage>
      <EASSendDataManageInvoice> </EASSendDataManageInvoice>
      <EASAdvertiser> </EASAdvertiser>
      <ConfigManage> </ConfigManage>
    </el-tabs>
  </el-card>
</template>

<script setup>
// import './css/index.css';
import { watch, ref, reactive, onBeforeMount, onMounted } from 'vue';
import PubSub from 'pubsub-js';
import ConfigManage from './configManage.vue';
import EASSendDataManage from './eASSendDataManage.vue';
import EASSendDataManageInvoice from './eASSendDataManageInvoice.vue';
import EASAdvertiser from './eASAdvertiser.vue';

const formLabelWidth = '140px';
const tabkey = ref('ConfigManage');

// router
import router from '@/router';
import profile from '@/network/profile';

import { ElMessage } from 'element-plus';

// tool
import { el } from 'element-plus/es/locale';

const TabClick = (data) => {
  tabkey.value = data.props.label;
  console.log(data.props.label);
};
</script>

<style scoped>
.el-button--text {
  margin-right: 15px;
}

.el-select {
  width: 300px;
}

.el-input {
  width: 300px;
}

.dialog-footer button:first-child {
  margin-right: 10px;
}
</style>
